import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import * as RequestStates from 'marketplace-ui-common/requestStates/RequestState';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import { GET_SEARCH_TAGS } from '../../../queries/searchTagQuery';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup'; // @ts-expect-error module is untyped

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';

const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});

const SearchTagFilter = ({
  disabled,
  offeringType,
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_SEARCH_TAGS, {
    variables: {
      offeringType
    }
  });
  const searchTagsOptions = useMemo(() => {
    const searchTagsData = data || previousData;

    if (!searchTagsData) {
      return [];
    }

    const {
      searchTags: {
        tags
      }
    } = searchTagsData;

    if (!tags) {
      return [];
    }

    return tags.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const searchTagsRequestState = useMemo(() => {
    if (loading) {
      return RequestStates.PENDING;
    }

    if (error) {
      return RequestStates.FAILED;
    }

    if (!data && !previousData) {
      return RequestStates.UNINITIALIZED;
    }

    return RequestStates.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: searchTagsRequestState,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.searchTags.title'),
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.TAGS,
      onChange: onChange,
      options: searchTagsOptions,
      scrollable: scrollable,
      searchable: true,
      value: value,
      virtualized: scrollable
    })
  });
};

export default SearchTagFilter;